import { SET_SUBSCRIBER_PRODUCTS, SET_SUBSCRIBER_PRODUCT_DETAIL } from './actions';

const INITIAL_STATE = {
     list: [],
     current: null,
};

const productReducer = (state = INITIAL_STATE, action) => {
     switch (action.type) {
          case SET_SUBSCRIBER_PRODUCTS: {
               return { ...state, list: action.payload };
          }
          case SET_SUBSCRIBER_PRODUCT_DETAIL: {
               return { ...state, current: action.payload };
          }
          default:
               return state;
     }
};

export default productReducer;
